// extracted by mini-css-extract-plugin
export default {"badgeContainer":"Badge_badgeContainer__kOP2c","badge":"Badge_badge__S901r"};